const getters = {
  token: state => state.user.token,
  baseInfo: state => state.user.baseInfo,
  role: state => state.user.role,
  infoList: state => state.user.infoList,
  nextRole: state => state.user.nextRole,
  getBaseInfo: state => state.user.getBaseInfo,
  followInfoList: state => state.user.followInfoList,
  reocrdList: state => state.user.reocrdList,
  queryListName: state => state.user.queryListName,
  queryPage: state => state.user.queryPage,
  checkPage: state => state.user.checkPage,
  followPage: state => state.user.followPage,
  activityBack: state => state.user.activityBack,
  // 聊天相关getters
  conversations: state => state.chat.conversations,
  currentConversation: state => state.chat.currentConversation,
  chatMessages: state => state.chat.messages,
  unreadCount: state => state.chat.unreadCount,
  hasNewMessage: state => state.chat.hasNewMessage,
  latestMessage: state => state.chat.latestMessage
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js